export const corvidBundlesConfig = {
    parts: false,
    components: true,
    host: true,
};
export const corvidConventions = {
    getComponentName: ({ componentName }) => {
        return componentName;
    },
    patterns: [
        {
            part: 'sdk',
            path: '{,*/}%ComponentName%/corvid/%ComponentName%.corvid.ts',
        },
        {
            part: 'autoComplete',
            path: '{,*/}%ComponentName%/corvid/%ComponentName%.autoComplete.ts',
        },
    ],
};
//# sourceMappingURL=corvid.js.map